import { Injectable } from '@angular/core';
import { ApiRoutes } from '@sb/library/api';
import { SortDirection } from '@sb/library/base';
import { LanguageDisplayItem } from '@sb/library/data-models';
import { map, Observable, of } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class LanguagesManager {
    private _languages: LanguageDisplayItem[] = [];
    private _languagesObservable: Observable<LanguageDisplayItem[]>;
    
    constructor () {
        this._languagesObservable = ApiRoutes.Localization.Languages.GetAll.Call().pipe(map(languages => 
            languages.orderByKey('DisplayName', SortDirection.Ascending)
        ));

        this._languagesObservable.subscribe(languages => {
            this._languages = languages;
            this._languagesObservable = of(this._languages);
        });
    }

    GetLanguageFromLocale(localeName: string | null): LanguageDisplayItem | null {
        if (!localeName) {
            return null;
        }
        const languageCodeFromLocale = localeName.split(/[-_]/)[0].toLowerCase();
        // direct primary language code match (e.g. "en" from "en-GB")
        const match = this._languages.find(l => l.Code!.toLowerCase() === languageCodeFromLocale);

        return match ?? null;
    }

    get languages(): LanguageDisplayItem[] {
        return this._languages;
    }

    set languages(value: LanguageDisplayItem[]) {
        this._languages = value.orderByKey('DisplayName', SortDirection.Ascending);
        this._languagesObservable = of(this._languages);
    }

    get languagesObservable(): Observable<LanguageDisplayItem[]> {
        return this._languagesObservable;
    }

}
